import React, { useEffect, useContext } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { AuthContext } from '../../App';
export function Layout() {
  const {
    isAuthenticated,
    userRole
  } = useContext(AuthContext);
  const navigate = useNavigate();
  // Redirect if not authenticated
  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login');
    }
  }, [isAuthenticated, navigate]);
  if (!isAuthenticated) return null;
  return <div className="flex h-screen overflow-hidden bg-gray-900" data-id="element-491">
      <Sidebar userRole={userRole} data-id="element-492" />
      <div className="flex flex-col flex-1 overflow-hidden" data-id="element-493">
        <Header data-id="element-494" />
        <main className="flex-1 overflow-y-auto p-6 bg-gray-900" data-id="element-495">
          <div className="container mx-auto max-w-7xl" data-id="element-496">
            <Outlet data-id="element-497" />
          </div>
        </main>
      </div>
    </div>;
}